import { ServerEmptyHandler } from "./ServerHandler";
import { ServerUploadGameHandler } from "./ServerUploadGameHandler";
import {ServerBCO} from "./ServerBCO";
import { ServerAssistant } from "./ServerAssistant";

export default class Network {
	private static mapServerEnumWithServerHandler = new Map();

	private static serverEmptyHandler: ServerEmptyHandler = new ServerEmptyHandler();

	private static internetAvailability: InternetAvailability | null;

	static {
		Network.mapServerEnumWithServerHandler.set(ServerUploadGameHandler, new ServerUploadGameHandler());
		Network.mapServerEnumWithServerHandler.set(ServerBCO, new ServerBCO());
		Network.mapServerEnumWithServerHandler.set(ServerAssistant, new ServerAssistant());
	}


	static withServerUploadGame(): ServerUploadGameHandler {
		return Network.mapServerEnumWithServerHandler.get(ServerUploadGameHandler);
	}

	static withServerBCO(): ServerBCO {
		return Network.mapServerEnumWithServerHandler.get(ServerBCO);
	}

	static withServerAssistant(): ServerAssistant {
		return Network.mapServerEnumWithServerHandler.get(ServerAssistant);
	}
}

export type InternetAvailability = {
	available: boolean,
	hostUrl?: string,
	err?: any,
}
